module.exports = __webpack_public_path__ + "static/img/07.0fe0187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/07.jpg
// module id = BJ2a
// module chunks = 0